/**
 * @generated SignedSource<<8d90a6082310d80c3fa26bfd913c28fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleCarouselVariant_viewer$data = {
  readonly saleItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarousel_items">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarousel_viewer">;
  readonly " $fragmentType": "HpSharedFeaturedModuleCarouselVariant_viewer";
};
export type HpSharedFeaturedModuleCarouselVariant_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModuleCarouselVariant_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarouselVariant_viewer">;
};

import HpSharedFeaturedModuleCarouselVariantPaginationQuery_graphql from './HpSharedFeaturedModuleCarouselVariantPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "saleItems"
],
v1 = {
  "kind": "Variable",
  "name": "fetchFavorites",
  "variableName": "hasUserId"
},
v2 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hasUserId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uriRef"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": HpSharedFeaturedModuleCarouselVariantPaginationQuery_graphql
    }
  },
  "name": "HpSharedFeaturedModuleCarouselVariant_viewer",
  "selections": [
    {
      "alias": "saleItems",
      "args": [
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "ItemSearchItemsConnection",
      "kind": "LinkedField",
      "name": "__HpSharedFeaturedModuleCarouselVariant_saleItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": [
                    (v1/*: any*/),
                    {
                      "kind": "Literal",
                      "name": "isTrade",
                      "value": false
                    },
                    {
                      "kind": "Variable",
                      "name": "priceBookName",
                      "variableName": "priceBookName"
                    },
                    (v2/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "HpSharedItemTilesCarousel_items"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "d7ad4f0467fad241d34298e7925466a5";

export default node;
